import { apiClient } from "~/utils/apiClient";

export interface FetchedMcpAppResource {
  // Exactly one is set — `html` for legacy inline `ui://` bundles, `url` for resources
  // migrated to serve a URL.
  html: string | null;
  url: string | null;
}

/**
 * Fetches an MCP app resource and classifies it by content type: legacy `ui://` resources
 * serve an inline HTML bundle (`text/html`), while migrated ones serve a URL
 * (`text/uri-list`) the panel should be pointed at directly instead.
 */
export async function fetchMcpAppResource(
  fetchUrl: string,
  options?: { signal?: AbortSignal }
): Promise<FetchedMcpAppResource> {
  const res = await apiClient<Response>(fetchUrl, {
    expectsResponse: true,
    signal: options?.signal,
  });
  const contentType = res.headers.get("content-type") ?? "";
  const body = await res.text();
  return contentType.includes("html") ? { html: body, url: null } : { html: null, url: body };
}
